import { theme } from 'antd';
import { compactTokens, compactComponents } from './compact';
import { standardTokens, standardComponents } from './standard';
const { defaultAlgorithm, compactAlgorithm } = theme;

export const getThemeConfig = (isCompact: boolean) => ({
  cssVar: true,
  algorithm: isCompact ? compactAlgorithm : defaultAlgorithm,
  token: isCompact ? compactTokens : standardTokens,
  components: isCompact ? compactComponents : standardComponents,
});
